<template>
  <v-form lazy-validation v-model="valid" ref="form">
    <v-row>
      <v-col cols="12" sm="12" md="11" lg="11">
        <!-- Header fields: same as Create Multi -->
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Date</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-menu
                  v-model="menuDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      flat
                      dense
                      background-color="white"
                      v-model="form.kasbonDate"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.kasbonDate"
                    :allowed-dates="getAllowedDates()"
                    @input="menuDate = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Payment<span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-select
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.paymentMethod"
                  :items="listPaymentMethod"
                  :rules="[v => !!v || 'Payment is required']"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Currency</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-select
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.currency"
                  :items="dropDownCurrency"
                  :rules="[v => !!v || 'Currency is required']"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Remark</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-textarea
                  outlined
                  flat
                  rows="3"
                  background-color="white"
                  v-model="form.remark"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Tax Date</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-menu
                  v-model="menuTaxDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      flat
                      dense
                      background-color="white"
                      v-model="form.taxDate"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.taxDate"
                    @input="menuTaxDate = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>DPP</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.dppAmount"
                  type="number"
                  persistent-hint
                  :hint="formatPrice(form.dppAmount)"
                  :rules="[v => v >= 0 || 'DPP must be 0 or more']"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Tax Serial Number</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.taxSerialNumber"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- Employee section with per-employee requirements -->
        <v-row>
          <v-col cols="12">
            <v-tabs vertical>
              <v-tab background-color="light-blue accent-3" dark class="px-0">
                <v-icon>mdi-account-multiple</v-icon>
              </v-tab>
              <v-tab-item>
                <v-card flat class="px-2">
                  <v-row>
                    <v-col cols="12" sm="12" md="4" lg="4">
                      <v-autocomplete
                        outlined
                        flat
                        dense
                        :items="employees"
                        item-text="name"
                        return-object
                        background-color="white"
                        v-model="employee"
                        @change="onChangeEmployee"
                        label="Employee"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="8"
                      lg="8"
                      align-self="start"
                      class="text-right pb-0"
                    >
                      <p class="headline font-italic">
                        Employee <span class="red--text">*</span>
                        <span class="subtitle-2 font-italic ml-2"
                          >(each employee has their own requirements)</span
                        >
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-data-table
                        :headers="headerEmployee"
                        :items="form.employees"
                        disable-pagination
                        hide-default-footer
                        @click:row="onClickRowEmployee"
                        item-key="index"
                      >
                        <template v-slot:item.no="{ index }">
                          {{ index + 1 }}
                        </template>
                        <template v-slot:item.accountNumber="{ item }">
                          {{ getAccountNumber(item) }}
                        </template>
                        <template v-slot:item.totalAmount="{ item }">
                          {{ formatPrice(getEmployeeTotalAmount(item)) }}
                        </template>
                        <template v-slot:item.itemsCount="{ item }">
                          {{ item.items ? item.items.length : 0 }}
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>
      </v-col>

      <!-- Save button -->
      <v-col cols="12" sm="12" md="1" lg="1" class="py-0">
        <v-row class="py-0">
          <v-col cols="12" class="mb-4 py-0">
            <v-btn v-if="$rbac.can('kasbon-general.create')" color="primary" @click="submit">
              <v-icon large>mdi-content-save</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <dialog-employee-with-items
      :item="item"
      :index="index"
      :dialog="dialogEmployee"
      :banks="banks"
      :listWo="listWo"
      :listCategory="listCategory"
      :listTemplate="listTemplate"
      @close="closeEmployee"
      @save="addEmployee"
      @deleteItem="deleteEmployee"
    ></dialog-employee-with-items>
  </v-form>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import DialogEmployeeWithItems from "./DialogEmployeeWithItems.vue";
import { fiscalMonthMixin } from "@/services/mixins/fiscalMonthMixin";

export default {
  name: "create-general-kasbon-multi-per-employee",
  mixins: [fiscalMonthMixin],
  components: {
    DialogEmployeeWithItems,
  },
  data: () => ({
    defaultForm: {
      kasbonDate: moment().format("yyyy-MM-DD"),
      paymentMethod: "",
      remark: "",
      currency: "IDR",
      status: "Outstanding",
      taxDate: moment().format("yyyy-MM-DD"),
      dppAmount: 0,
      taxSerialNumber: "",
      employees: [],
    },
    menuDate: false,
    menuTaxDate: false,
    form: {},
    dialogEmployee: false,
    item: {},
    index: -1,
    employee: null,
    listCategory: [],
    listTemplate: [],
    listWo: [],
    valid: true,
    listPaymentMethod: ["Cash", "Transfer"],
    headerEmployee: [
      { text: "No", value: "no", sortable: false, divider: true },
      { text: "Name", value: "name", sortable: false, divider: true },
      { text: "Division", value: "division", sortable: false, divider: true },
      { text: "Account Number Bank", value: "accountNumber", sortable: false, divider: true },
      { text: "Total Amount", value: "totalAmount", sortable: false, divider: true },
      { text: "Requirements", value: "itemsCount", sortable: false, divider: true },
    ],
    banks: [],
  }),

  computed: {
    ...mapState("currency", ["dropDownCurrency"]),
    ...mapState("external", ["employees"]),
  },

  methods: {
    async submit() {
      if (this.$refs.form.validate() && this.form.employees.length > 0) {
        const emptyItemsEmployee = this.form.employees.find(e => !e.items || e.items.length === 0);
        if (emptyItemsEmployee) {
          this.$store.dispatch("toast", {
            type: "error",
            message: `Employee "${emptyItemsEmployee.name}" has no requirements`,
          });
          return;
        }

        this.$store.commit("SET_LOADER", true);
        await this.$store
          .dispatch("generalKasbon/createMultiPerEmployee", this.form)
          .then(() => {
            this.$store.commit("SET_LOADER", false);
            this.$router.push({ name: "General Kasbon" });
          })
          .catch(() => {
            this.$store.dispatch("toast", {
              type: "error",
              message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
            });
            this.$store.commit("SET_LOADER", false);
          });
      } else {
        if (this.form.employees.length === 0) {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Employee is required",
          });
        }
      }
    },
    deleteEmployee(index) {
      if (index > -1) {
        this.form.employees.splice(index, 1);
        this.dialogEmployee = false;
        this.employee = null;
      }
    },
    addEmployee(item) {
      if (this.index > -1) {
        this.form.employees.splice(this.index, 1, item);
      } else {
        this.form.employees.push({ ...item });
      }
      this.employee = null;
    },
    closeEmployee() {
      this.dialogEmployee = false;
    },
    onClickRowEmployee(item) {
      this.item = item;
      this.index = this.form.employees.indexOf(item);
      this.dialogEmployee = true;
    },
    async onChangeEmployee(val) {
      this.item = {
        employeeId: val.hrId,
        name: val.name,
        division: val.department.name,
        bankAccountNumber: val.bankAccountNumber,
        ownerBank: val.name,
        external: false,
        dos: [],
        wos: [],
        sites: [],
        accountNumberId: null,
        externalAccountNumber: null,
        items: [],
      };
      this.index = -1;
      this.getWos(val.hrId);
      this.dialogEmployee = true;
    },
    async getWos(employeeId) {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("wo/getByEmployeeId", employeeId)
        .then(response => {
          this.listWo = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    async getBankExternals() {
      await this.$store.dispatch("bank/getExternals").then(response => {
        this.banks = response.data;
      });
    },
    getAccountNumber(item) {
      if (item.external) {
        return item.externalAccountNumber.accountNumber;
      }
      return item.bankAccountNumber;
    },
    getEmployeeTotalAmount(employee) {
      if (!employee.items || employee.items.length === 0) return 0;
      return employee.items
        .filter(x => x.calculated)
        .map(x => x.amount)
        .reduce((a, b) => a + b, 0);
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    async getListCategory() {
      const response = await this.$store.dispatch("generalKasbon/getListCategory");
      if (response.status === 200) {
        this.listCategory = response.data;
      }
    },
    async getTemplate() {
      await this.$store.dispatch("generalKasbon/getTemplates").then(response => {
        this.listTemplate = response.data;
      });
    },
    async getInitialData() {
      this.$store.commit("SET_LOADER", true);
      Promise.all([
        await this.$store.dispatch("currency/getListCurrency"),
        await this.$store.dispatch("external/getEmployees"),
        this.getListCategory(),
        this.getTemplate(),
        this.getBankExternals(),
      ])
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },

  mounted() {
    this.getInitialData();
    this.form = Object.assign({}, this.defaultForm);
  },
};
</script>

<style></style>
